// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { GridActionsCellItem } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import { useActiveRoute } from "@/hooks";
import { redirect } from "@/utils/helpers";
import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";

export function RedirectAction({ id }: any) {
  const { t } = useDynamicTranslation("shared");
  const { activeRoute } = useActiveRoute();

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={t("edit")}>
          <EditIcon />
        </Tooltip>
      }
      label="Edit"
      onClick={() => {
        redirect({
          target: `${activeRoute.fullPath}/edit?id=${id}`,
        });
      }}
    />
  );
}

export function StartEditingAction({ onClick }: any) {
  const { t } = useDynamicTranslation("shared");

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={t("edit")}>
          <EditIcon />
        </Tooltip>
      }
      label="Edit"
      onClick={onClick}
    />
  );
}

export function SaveAction({ onClick }: any) {
  const { t } = useDynamicTranslation("shared");

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={t("save")}>
          <SaveIcon color="inherit" />
        </Tooltip>
      }
      label="Save"
      onClick={onClick}
    />
  );
}

export function CancelEditingAction({ onClick }: any) {
  const { t } = useDynamicTranslation("shared");

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={t("cancel")}>
          <CancelIcon color="inherit" />
        </Tooltip>
      }
      label="Cancel"
      onClick={onClick}
    />
  );
}

RedirectAction.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

StartEditingAction.propTypes = {
  onClick: PropTypes.func.isRequired,
};

SaveAction.propTypes = {
  onClick: PropTypes.func,
};

CancelEditingAction.propTypes = {
  onClick: PropTypes.func.isRequired,
};
